import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Card, PageShell } from '../components/ui';

/**
 * Legal Notice (Mentions Legales) page.
 * Required by French Law No. 2004-575 of June 21, 2004 (LCEN), Article 6.
 */
export default function MentionsLegalesPage() {
  const { t } = useTranslation();

  return (
    <PageShell maxWidth="3xl" mainClassName="py-10">
      <h1 className="mb-8 text-3xl font-bold text-slate-900 dark:text-white">{t('legal.mentions.title')}</h1>

      <Card className="prose max-w-none space-y-6 p-8 text-sm leading-relaxed text-slate-600 dark:prose-invert dark:text-slate-300">
        <p className="text-xs text-slate-500 dark:text-slate-400">
          {t('legal.mentions.intro')}
        </p>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.mentions.section1.title')}</h2>
          <ul className="list-none space-y-1 pl-0">
            <li><strong>{t('legal.mentions.section1.companyName')}</strong> {t('legal.mentions.section1.companyValue')}</li>
            <li><strong>{t('legal.mentions.section1.legalForm')}</strong> {t('legal.mentions.section1.legalFormValue')}</li>
            <li><strong>{t('legal.mentions.section1.siret')}</strong> {t('legal.mentions.section1.siretValue')}</li>
            <li><strong>{t('legal.mentions.section1.phone')}</strong> {t('legal.mentions.section1.phoneValue')}</li>
            <li><strong>{t('legal.mentions.section1.email')}</strong> {t('legal.mentions.section1.emailValue')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.mentions.section2.title')}</h2>
          <p>
            <Trans i18nKey="legal.mentions.section2.body" components={{ strong: <strong /> }} />
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.mentions.section3.title')}</h2>
          <ul className="list-none space-y-1 pl-0">
            <li><strong>{t('legal.mentions.section3.companyName')}</strong> {t('legal.mentions.section3.companyValue')}</li>
            <li><strong>{t('legal.mentions.section3.address')}</strong> {t('legal.mentions.section3.addressValue')}</li>
            <li><strong>{t('legal.mentions.section3.phone')}</strong> {t('legal.mentions.section3.phoneValue')}</li>
            <li><strong>{t('legal.mentions.section3.website')}</strong> {t('legal.mentions.section3.websiteValue')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.mentions.section4.title')}</h2>
          <p>{t('legal.mentions.section4.body')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.mentions.section5.title')}</h2>
          <p>
            <Trans
              i18nKey="legal.mentions.section5.p1"
              components={{
                link: <Link to="/privacy" className="text-blue-600 hover:underline dark:text-blue-400" />,
              }}
            />
          </p>
          <ul className="list-none space-y-1 pl-0">
            <li><strong>{t('legal.mentions.section5.dpo')}</strong> {t('legal.mentions.section5.dpoValue')}</li>
            <li><strong>{t('legal.mentions.section5.dpoContact')}</strong> {t('legal.mentions.section5.dpoContactValue')}</li>
          </ul>
          <p>
            <Trans
              i18nKey="legal.mentions.section5.p2"
              components={{
                profileLink: <Link to="/profile" className="text-blue-600 hover:underline dark:text-blue-400" />,
              }}
            />
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.mentions.section6.title')}</h2>
          <p>{t('legal.mentions.section6.body')}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">{t('legal.mentions.section7.title')}</h2>
          <p>{t('legal.mentions.section7.body')}</p>
        </section>

        <p className="border-t border-slate-200 pt-4 text-xs text-slate-400 dark:border-white/10 dark:text-slate-500">
          {t('legal.mentions.lastUpdated')}
        </p>
      </Card>
    </PageShell>
  );
}
